import StoreFrontEvent from 'components/storeFrontEvents';

const Settings = () => {
  return <StoreFrontEvent />;
};

export default Settings;
